import React, { useState, useEffect } from "react";
import "../styles/MockInterviewPage.css";
import { FaUserFriends, FaLinkedin, FaYoutube } from "react-icons/fa";
import { MdQuiz } from "react-icons/md";
import { BsCameraVideoFill } from "react-icons/bs";

const typingWords = ["Interview Skills", "Communication", "Confidence"];
const TYPING_SPEED = 90;
const DISPLAY_TIME = 2000;

const TypingWord = ({ onTypingEnd }) => {
  const [wordIndex, setWordIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [typing, setTyping] = useState(true);

  useEffect(() => {
    let timeout;
    if (typing) {
      if (displayText.length < typingWords[wordIndex].length) {
        timeout = setTimeout(() => {
          setDisplayText(
            typingWords[wordIndex].slice(0, displayText.length + 1)
          );
        }, TYPING_SPEED);
      } else {
        timeout = setTimeout(() => setTyping(false), DISPLAY_TIME);
      }
    } else {
      if (displayText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayText(displayText.slice(0, -1));
        }, TYPING_SPEED / 2);
      } else {
        const nextIndex = (wordIndex + 1) % typingWords.length;
        setWordIndex(nextIndex);
        setTyping(true);
        if (nextIndex === 0) onTypingEnd();
      }
    }
    return () => clearTimeout(timeout);
  }, [displayText, typing, wordIndex, onTypingEnd]);

  return (
    <span className="typing-word">
      {displayText}
      <span className="caret">|</span>
    </span>
  );
};

const fallbackMentor = {
  name: "Manikonda Sharat",
  email: "manikondasharat@gmail.com",
  photo: "/images/Sharatsir.jpg",
  description:
    "Sharat Sir brings over a two decade of experience helping students ace real-world technical interviews. His mentoring focuses on structured mock sessions, confidence building, and targeted feedback to help you land your dream job.",
  linkedin: "https://www.linkedin.com/in/sharat-manikonda/",
  youtube: "https://www.youtube.com/@sharatmanikonda",
};

const MockInterviewPage = () => {
  const [mentor, setMentor] = useState(fallbackMentor);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    fetch("https://api.instilit.com/api/check-login/", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setIsAuthenticated(data.isAuthenticated))
      .catch((err) => console.error("Login check failed", err));

    fetch("https://api.instilit.com/api/mentor/")
      .then((res) => res.json())
      .then((data) => {
        if (data.name) {
          setMentor((prev) => ({
            ...prev,
            ...data,
          }));
        }
      })
      .catch((err) => {
        console.error("Mentor fetch failed", err);
        setMentor(fallbackMentor);
      });
  }, []);

  return (
    <div className="mock-interview-page">
      {/* Page Title Section */}
      <div className="top-heading-container">
        <h1 className="top-heading">Mock Interviews</h1>
        <p className="heading-subtext">
          Real-time 1-on-1 technical interview practice with expert mentors.
        </p>
      </div>

      {/* Main Content Area: Mentor card and Booking button */}
      <div className="content-container">
        {/* Mentor Card */}
        <div className="mentor-details">
          <div className="typing-block">
            <h2 className="mentor-heading-top">Boost your</h2>
            <div className="mentor-typing-container">
              <TypingWord onTypingEnd={() => {}} />
            </div>
            <h2 className="mentor-heading-bottom">with our mentor</h2>
          </div>

          <img src={mentor.photo} alt={mentor.name} className="mentor-img" />
          <h3 className="mentor-name">{mentor.name}</h3>

          {/* Social Links */}
          <div className="social-links">
            {mentor.linkedin && (
              <a
                href={mentor.linkedin}
                className="social-icon"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin
                  size={30}
                  className="pb-0.5 text-blue-600 hover:text-blue-800 transition-colors"
                />
                <span className="icon-label">LinkedIn</span>
              </a>
            )}
            {mentor.youtube && (
              <a
                href={mentor.youtube}
                className="social-icon"
                aria-label="YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube
                  size={32}
                  className="text-red-500 hover:text-red-700 transition-colors"
                />
                <span className="icon-label">YouTube</span>
              </a>
            )}
          </div>

          <p className="mentor-desc">{mentor.description}</p>

          {/* Contact Mentor link shows only if authenticated */}
          {isAuthenticated ? (
            <a href={`mailto:${mentor.email}`} className="mentor-contact">
              Contact Mentor
            </a>
          ) : (
            <p className="mentor-contact-login-msg">
              Please login to view contact details
            </p>
          )}
               <a
              href="https://forms.gle/CBDkm412nj8TH9co7"
              className="book-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book Now ₹49
            </a>   
        </div>
      </div>

     
      <div className="peer-features-section">
        <div className="feature">
          <FaUserFriends className="feature-icon" size={48} />
          <h4 className="feature-title">Personal Peer Matching</h4>
          <p className="feature-desc">
            Get matched with practice partners based on your background and
            target goals.
          </p>
        </div>

        <div className="feature">
          <MdQuiz className="feature-icon" size={48} />
          <h4 className="feature-title">Real Interview Questions</h4>
          <p className="feature-desc">
            Practice questions tailored to your skill set and upcoming
            interviews.
          </p>
        </div>

        <div className="feature">
          <BsCameraVideoFill className="feature-icon" size={48} />
          <h4 className="feature-title">1-on-1 HD Sessions</h4>
          <p className="feature-desc">
            Face-to-face live mock interviews with personalized guidance and
            feedback.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MockInterviewPage;